<template>
  <div style="display: flex;">
    <el-tree
    :data="treeData1"
        default-expand-all
        node-key="id"
        ref="tree1"
        :expand-on-click-node="false"
        empty-text="暂无权限节点"
        :allow-drop="returnFalse"
        draggable
        @node-drag-start="handleDragstart_tree1"
        @node-drag-end="handleDragend_tree1"
        @node-drop="nodedrop_tree1"
        @node-drag-enter="dragEnter_tree1">
    </el-tree>
    <el-tree
       :data="treeData2"
        default-expand-all
        node-key="id"
        ref="tree2"
        draggable
        :default-checked-keys="defaultchecked"
        @node-drag-enter="dragEnter_tree2"
        :expand-on-click-node="false"
        empty-text="暂无权限节点"
        :allow-drop="allowdrop_tree2">
        <span class="custom-tree-node" slot-scope="{ node, data }">

          <span v-text="data.label" v-if="data.isdistinguish_agent == 1" style="color:red"></span>
          <span v-text="data.label" v-else-if="data.isdistinguish_agent == 0" ></span>

          <span>
            <el-button
              type="text"
              v-if="node.level == 1 || node.level == 2"
              size="mini"
              @click="() => edit(node, data)"
              >编辑</el-button
            >
            <el-button
              type="text"
              v-if="node.level == 1"
              size="mini"
              @click="() => append(node, data)"
              >增加</el-button
            >
            <el-button type="text" size="mini" @click="() => remove(node, data)"
              >删除</el-button
            >
          </span>
        </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  data() {
    return {
      treeData1: [
    {
        "label": "财务对账",
        "children": [
            {
                "path": "/api/v1/member/finance/fapiao/list/",
                "label": "发票列表"
            },
            {
                "path": "/api/v1/member/finance/fapiao/detail",
                "label": "发票详情"
            },
            {
                "path": "/api/v1/member/finance/fapiao/edit",
                "label": "发票编辑"
            },
            {
                "path": "/api/v1/member/finance/fapiao/export",
                "label": "发票列表导出"
            }
        ]
    },
    {
        "label": "后台维修管理",
        "children": [
            {
                "path": "/api/v1/member/faulthelmlock/list/",
                "label": "头盔锁故障列表"
            },
            {
                "path": "/api/v1/member/faulthelmlock/listtotal",
                "label": "头盔锁故障列表总数"
            },
            {
                "path": "/api/v1/member/faultcamera/list/",
                "label": "摄像头故障列表"
            },
            {
                "path": "/api/v1/member/faultcamera/listtotal",
                "label": "摄像头列表总数"
            },
            {
                "path": "/api/v1/member/faultlog/list/",
                "label": "故障工单列表"
            },
            {
                "path": "/api/v1/member/faulthelmlock/download",
                "label": "头盔锁故障列表下载"
            },
            {
                "path": "/api/v1/member/faultcamera/download",
                "label": "摄像头故障列表下载"
            }
        ]
    },
    {
        "label": "骑行订单管理",
        "children": [
            {
                "path": "/api/v1/member/use_log/closeapply_detailbyuselogid",
                "label": "用户申请还车跳转详情"
            },
            {
                "path": "/api/v1/member/use_log/remark",
                "label": "骑行订单备注"
            }
        ]
    },
    {
        "label": "后台站点管理",
        "children": [
            {
                "path": "/api/v1/member/agent/park_shape_list",
                "label": "站点列表"
            },
            {
                "path": "/api/v1/member/agent/coefficient/list",
                "label": "编辑电池里程系数"
            },
            {
                "path": "/api/v1/member/agent/coefficient/edit",
                "label": "电池里程系数列表"
            },
            {
                "path": "/api/v1/member/agent/battery_curve/info",
                "label": "查看电压曲线-基于站点配置"
            },
            {
                "path": "/api/v1/member/agent/battery_curve/export",
                "label": "下载电压曲线-基于站点配置"
            },
            {
                "path": "/api/v1/member/agent/forlogin",
                "label": "进入站点后台登录"
            },
            {
                "path": "/api/v1/member/piece_conf/detail",
                "label": "工单计价配置-详情"
            },
            {
                "path": "/api/v1/member/piece_conf/edit",
                "label": "工单计价配置-编辑"
            },
            {
                "path": "/api/v1/member/piece/battery/fix",
                "label": "工单计价配置-编辑"
            }
        ]
    },
    {
        "label": "服务区管理",
        "children": [
            {
                "path": "/api/v1/member/fence/special_list",
                "label": "服务区运营区列表"
            },
            {
                "path": "/api/v1/member/fence/special/list",
                "label": "添加片区"
            },
            {
                "path": "/api/v1/member/fence/special/add",
                "label": "添加片区"
            },
            {
                "path": "/api/v1/member/fence/special/edit",
                "label": "编辑片区信息"
            },
            {
                "path": "/api/v1/member/fence/special/del",
                "label": "删除片区"
            },
            {
                "path": "/api/v1/member/fence/special/setstatus",
                "label": "禁启用片区"
            }
        ]
    },
    {
        "label": "报表管理",
        "children": [
            {
                "path": "/api/v1/member/agent/metabase/MB248",
                "label": "配件月度申请报表"
            },
            {
                "path": "/api/v1/member/agent/metabase/MB254",
                "label": "维修工单统计"
            },
            {
                "path": "/api/v1/member/agent/metabase/MB270",
                "label": "车辆资产报表"
            },
            {
                "path": "/api/v1/member/agent/metabase/MB277",
                "label": "骑行卡销售报表"
            },
            {
                "path": "/api/v1/member/agent/metabase/MB227",
                "label": "换电工作报表"
            },
            {
                "path": "/api/v1/member/agent/metabase/MB251",
                "label": "换电工作汇总"
            },
            {
                "path": "/api/v1/member/agent/metabase/MB245",
                "label": "车辆异常报表"
            },
            {
                "path": "/api/v1/member/agent/metabase/MB263",
                "label": "配件消耗明细报表"
            }
        ]
    },
    {
        "label": "自行车管理",
        "children": [
            {
                "path": "/api/v1/member/bike/info",
                "label": "车辆详情v2"
            },
            {
                "path": "/api/v1/member/bike/scraporno",
                "label": "设置报废或正常"
            },
            {
                "path": "/api/v1/member/bike/baseinfo",
                "label": "车辆基础信息"
            },
            {
                "path": "/api/v1/member/bike/baseedit",
                "label": "车辆基础信息编辑"
            },
            {
                "path": "/api/v1/member/bikelable/byordertype/list/",
                "label": "自行车工单大屏"
            },
            {
                "path": "/api/v1/member/bikelable/byordertype/listv2",
                "label": "自行车工单大屏"
            },
            {
                "path": "/api/v1/member/bikelable/byqrcode/detail",
                "label": "单个车辆的工单标签"
            }
        ]
    },
    {
        "label": "配件出货管理",
        "children": [
            {
                "path": "/api/v1/member/accessories_buylog/warehouse_delivery",
                "label": "仓库发货"
            }
        ]
    },
    {
        "label": "用户管理",
        "children": [
            {
                "path": "/api/v1/member/users/unregister",
                "label": "用户注销"
            },
            {
                "path": "/api/v1/member/users/setlevel_ipmort",
                "label": "设置用户角色"
            },
            {
                "path": "/api/v1/member/users/detail/usercredit/config",
                "label": "添加信用分记录-记录项列表"
            },
            {
                "path": "/api/v1/member/users/detail/usercredit/add",
                "label": "添加信用分记录"
            },
            {
                "path": "/api/v1/member/users/detail/growthlist/",
                "label": "成长值明细"
            },
            {
                "path": "/api/v1/member/users/detail/growthlisttotal",
                "label": "成长值明细总数"
            },
            {
                "path": "/api/v1/member/users/detail/pointhdlist/",
                "label": "横店积分明细"
            },
            {
                "path": "/api/v1/member/users/detail/pointhdlisttotal",
                "label": "横店积分明细总数"
            },
            {
                "path": "/api/v1/member/users/detail/usergrowth/sysadd",
                "label": "添加信用分记录"
            },
            {
                "path": "/api/v1/member/users/detail/fapiao_whitelist/",
                "label": "添加信用分记录"
            },
            {
                "path": "/api/v1/member/users/realname/list/",
                "label": "用户实名列表"
            },
            {
                "path": "/api/v1/member/users/userdetail_ipmort",
                "label": "海外用户实名导入"
            }
        ]
    },
    {
        "label": "用户实体卡管理",
        "children": [
            {
                "path": "/api/v1/member/userscard/add",
                "label": "批量添加卡密"
            },
            {
                "path": "/api/v1/member/userscard/batchlist/",
                "label": "卡密批次列表"
            },
            {
                "path": "/api/v1/member/userscard/batchlisttotal",
                "label": "卡密批次列表总数"
            },
            {
                "path": "/api/v1/member/userscard/detaillist/",
                "label": "卡密批次列表总数"
            },
            {
                "path": "/api/v1/member/userscard/detaillist/",
                "label": "卡密批次列表总数"
            }
        ]
    },
    {
        "label": "公告管理",
        "children": [
            {
                "path": "/api/v1/member/oper_ad/add",
                "label": "添加公告"
            },
            {
                "path": "/api/v1/member/oper_ad/edit",
                "label": "编辑公告"
            },
            {
                "path": "/api/v1/member/oper_ad/list",
                "label": "公告列表"
            },
            {
                "path": "/api/v1/member/oper_ad/detail",
                "label": "公告详情"
            },
            {
                "path": "/api/v1/member/oper_ad/end_or_start",
                "label": "启禁用公告"
            },
            {
                "path": "/api/v1/member/oper_ad/del",
                "label": "删除公告"
            },
            {
                "path": "/api/v1/member/oper_ad/sort",
                "label": "公告排序"
            },
            {
                "path": "/api/v1/member/oper_ad/adlocationlist",
                "label": "公告位置列表"
            },
            {
                "path": "/api/v1/member/oper_ad/manualupdate_labeluser",
                "label": "手动刷新标签用户"
            }
        ]
    },
    {
        "label": "后台充值金额配置管理",
        "children": [
            {
                "path": "/api/v1/member/setting/rechargeownagentedit",
                "label": "充值金额站点独立配置"
            }
        ]
    },
    {
        "label": "骑行卡卡密管理",
        "children": [
            {
                "path": "/api/v1/member/setting/ridecard_secret_batch/add",
                "label": "添加骑行卡卡密"
            },
            {
                "path": "/api/v1/member/setting/ridecard_secret_batch/list/",
                "label": "骑行卡卡密批次"
            },
            {
                "path": "/api/v1/member/setting/ridecard_secret_detail/list/",
                "label": "骑行卡卡密详情"
            },
            {
                "path": "/api/v1/member/setting/ridecard_secret_detail/download",
                "label": "骑行卡卡密详情下载"
            }
        ]
    },
    {
        "label": "后台骑行卡折扣券配置管理",
        "children": [
            {
                "path": "/api/v1/member/setting/carddiscount_config/add",
                "label": "添加骑行卡折扣券配置"
            },
            {
                "path": "/api/v1/member/setting/carddiscount_config/edit",
                "label": "编辑骑行卡折扣券配置"
            },
            {
                "path": "/api/v1/member/setting/carddiscount_config/list",
                "label": "骑行卡折扣券配置列表"
            },
            {
                "path": "/api/v1/member/setting/carddiscount_config/enable",
                "label": "禁启用骑行卡折扣券配置"
            },
            {
                "path": "/api/v1/member/setting/carddiscount_config/typelist",
                "label": "骑行卡折扣券发放类型列表"
            }
        ]
    },
    {
        "label": "后台中控总库管理",
        "children": [
            {
                "path": "/api/v1/member/devicemainwhouse/import_getres",
                "label": "中控总库导入获取结果"
            }
        ]
    },
    {
        "label": "数据大屏对接前端接口管理",
        "children": [
            {
                "path": "/api/v1/member/largescreen/newestusers",
                "label": "最新注册用户"
            },
            {
                "path": "/api/v1/member/largescreen/30daystatiticsuselog",
                "label": "订单量日趋势（30日）"
            },
            {
                "path": "/api/v1/member/largescreen/30daystatiticsusers",
                "label": "新增用户日趋势（30日）"
            },
            {
                "path": "/api/v1/member/largescreen/beforetodayuselogandusercount",
                "label": "总订单数量+总用户数量统计"
            },
            {
                "path": "/api/v1/member/largescreen/testerday_todaylogcount",
                "label": "昨日今日订单和工单统计"
            },
            {
                "path": "/api/v1/member/largescreen/agent_list",
                "label": "启用的站点"
            }
        ]
    },
    {
        "label": "p点分级管理",
        "children": [
            {
                "path": "/api/v1/member/pid_grading_value/list",
                "label": " 进出p点的等级范围值"
            },
            {
                "path": "/api/v1/member/pid_classification/list",
                "label": "进出p点-p点分级统计"
            }
        ]
    },
    {
        "label": "统计报表",
        "children": [
            {
                "path": "/api/v1/member/agent_monthly_report/list/",
                "label": "站点考核指标列表"
            },
            {
                "path": "/api/v1/member/agent_monthly_report/total",
                "label": "站点考核指标列表总数"
            },
            {
                "path": "/api/v1/member/agent_monthly_report/export",
                "label": "站点考核指标列表导出"
            },
            {
                "path": "/api/v1/member/piece_report/list/",
                "label": "工单计价-列表"
            },
            {
                "path": "/api/v1/member/piece_report/total",
                "label": "工单计价-总数"
            },
            {
                "path": "/api/v1/member/piece_report/export",
                "label": "工单计价-导出"
            },
            {
                "path": "/api/v1/member/piece_report/dispatch/list/",
                "label": "工单计价-调度-列表"
            },
            {
                "path": "/api/v1/member/piece_report/dispatch/total",
                "label": "工单计价-调度-总数"
            },
            {
                "path": "/api/v1/member/piece_report/dispatch/export",
                "label": "工单计价-调度-导出"
            },
            {
                "path": "/api/v1/member/piece_report/cb/list/",
                "label": "工单计价-换电-列表"
            },
            {
                "path": "/api/v1/member/piece_report/cb/total",
                "label": "工单计价-换电-总数"
            },
            {
                "path": "/api/v1/member/piece_report/cb/export",
                "label": "工单计价-换电-导出"
            }
        ]
    },
    {
        "label": "武定监管平台",
        "children": [
            {
                "path": "/api/v1/member/bz_supv/bike_sync",
                "label": "车辆推送"
            },
            {
                "path": "/api/v1/member/bz_supv/fence_sync",
                "label": "车辆推送"
            }
        ]
    }
],
      treeData2: [
          {
            "id": 79,
            "label": "工作台111",
            "rule": "",
            "pid": 0,
            "sort": 0,
            "is_menu": 1,
            "isdistinguish_agent": 0,
            "children": [
              {
                "id": 579,
                "label": "实时运营报表111",
                "rule": "",
                "pid": 79,
                "sort": 0,
                "is_menu": 0,
                "isdistinguish_agent": 0,
                "children": [
                  {
                    "id": 580,
                    "label": "实时运营报表111",
                    "rule": "/api/v1/member/agent/metabase/MB1",
                    "pid": 579,
                    "sort": 0,
                    "is_menu": 1,
                    "isdistinguish_agent": 0,
                    "children": null
                  }
                ]
              }
            ]
          },
        ], // 树2的数据
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'id'
      },
      defaultchecked: [],
      nowNode:''
    };
  },
  methods: {
    returnFalse() {
      return false;
    },
    dragEnter_tree1() {
      this.nowNode = "";
      console.info("dragEnter_tree1 ", this.nowNode);
    },
    dragEnter_tree2(draggingNode, endNode) {
      console.info("dragEnter_tree2 ", this.nowNode);
      if (draggingNode.level == 1 || endNode.level == 1) {
        this.nowNode = "";
        return;
      }

      this.nowNode = endNode;
    },

    allowdrop_tree2(draggingNode, dropNode) {
      if (draggingNode.key > 0 || dropNode.level == 1) {
      console.info(true)
        this.nowNode = "";
        return false;
      } else {
        return true;
      }
    },
    nodedrop_tree1() {
      //console.info(a, b, c, d);
    },
    handledragstart_tree2() {
      return false;
    },

    handleDragstart_tree1(node, event) {
      this.$refs.tree2.$emit("tree-node-drag-start", event, { node: node });
    },

    handleDragend_tree1(draggingNode, endNode, position, event) {
      event.issuccess = false;
      this.$refs.tree2;

      // 插入一个空节点用于占位
      console.info("handleDragend_tree1 ", draggingNode, endNode);
      if (!this.nowNode) {
        this.$refs.tree2.dragState.draggingNode = null;
        this.$refs.tree2.$emit("tree-node-drag-end", event);
        return;
      }

      var label = "";
      var pid = this.nowNode.data.id;
      label = this.nowNode.data.label;

      if (this.nowNode.level == 3) {
        pid = this.nowNode.data.pid;
        label = this.nowNode.parent.label;
      }

      this.$confirm(
        `是否将"${draggingNode.label} 权限"移动至" ${label} "权限下`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          console.info(pid)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
          this.$refs.tree2.dragState.draggingNode = null;
          this.$refs.tree2.$emit("tree-node-drag-end", event);
          return;
        });
    },
  }
};
</script>
<style scoped>
/* 可以根据需要添加样式 */

.authority-nue {
  font-size: 14px;
  height: calc(100vh - 60px);
  border-right: 1px solid #eee;
  overflow-x: hidden;
  overflow-y: auto;
}
.authority-nue h4 {
  margin: 20px 5px 20px 20px;
  padding: 0;
}
.authority-nue ul {
  margin: 30px 20px 30px 20px;
}
.authority-nue ul li {
  margin: 20px 0;
  padding: 8px;
  /**/
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
}
.authority-nue ul li b {
  cursor: pointer;
}
.authority-nue ul li b.ischecked {
  color: #409eff;
}
/*	.authority-nue ul li.ischecked{
		background: #f5f5f5;
	}
	.authority-nue ul li.ischecked span{
		color: #000;
	}*/
.authority-nue ul li span {
  cursor: pointer;
  color: #888;
}
.authority-nue ul li span.spaned {
  color: #409eff;
}
.authority-nue .addgroup {
  width: 56%;
  color: #409eff;
  border: 1px dashed #409eff;
  padding: 10px 0;
  text-align: center;
  margin: 0 5px 0 20px;
  border-radius: 6px;
}

/*树形菜单*/
.my-trees {
  margin-top: 20px;
  height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}
.el-tree-node__content .el-tree-node__label {
  font-size: 13px;
}
/* 增删改查权限样式 */
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
/* >>> .el-input__inner {
  height: 20px;
} */

/* /deep/ .el-input__inner {
  height: 20px;
} */
</style>